<template>
  <div :class="classes" class="boolean-field">
    <div class="input-group inline-flex items-center flex-wrap spacer-x-3 spacer-y-2">
      <label class="w-full">{{ label }}</label>
      <div>
        <span :style="localField ? 'color: #6aca8a' : '#F0766E'" v-if="!editing || !editable">{{ localField ? 'YES' : 'NO' }}</span>
        <toggle-button
          v-else
          :sync="true"
          v-model="localField"
          :labels="{ checked: 'YES', unchecked: 'NO' }"
          :color="{ checked: $brandPrimary, unchecked: '#b7b7b7' }"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    editable: {
      required: false,
      default: true
    },
    field: {
      required: true,
      type: String
    },
    label: {
      required: true,
      type: String
    },
    fieldType: {
      required: false,
      default: 'text',
      type: String
    },
    classes: {
      required: false,
      default: '',
      type: String
    },
    booking: {
      required: true,
      type: Object
    },
    propertyMutator: {
      required: true,
      type: Function
    }
  },

  computed: {
    ...mapState('editing', ['editing']),

    localField: {
      get () {
        return this.booking[this.field]
      },
      set (value) {
        this.propertyMutator({
          property: this.field,
          value
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.boolean-field {
  width: 50%;
  @media (min-width: 575px) {
      width: calc(100% / 3);
  }
}
</style>
